<template>
  <div>
    <div class="col-12 column-assoc">
      <b-alert
        variant="danger"
        :show="error.length > 0"
      >
        {{ error }}
      </b-alert>
      <div class="row pb-4">
        <div class="col-3">
          <span class="h5 action-header">Oszlop</span>
        </div>
        <div class="col-4">
          <span class="h5 action-header">Típus</span>
        </div>
        <div class="col-1">
          <b-button
            variant="text"
            size="sm"
            @click="clearAll"
          >
            <i class="fas fa-trash text-danger" />
          </b-button>
        </div>
        <div class="col-4">
          <span class="h5 action-header">Minta</span>
        </div>
      </div>
      <div
        v-for="(column, index) in columns"
        :key="index"
        class="row"
      >
        <div class="col-3 form-group text-truncate">
          <span class="import-text">{{ column.name }}</span>
        </div>
        <div class="col-4 form-group">
          <select
            id="subject"
            v-model="column.value"
            class="form-control"
          >
            <option
              v-for="(member, memberIndex) in members"
              :key="memberIndex"
              :disabled="member.selected && column.value !== member.name"
              :value="member.name"
            >
              {{ member.label }}
            </option>
          </select>
        </div>
        <div class="col-1">
          <b-button
            variant="text"
            size="sm"
            @click="clear(column.name)"
          >
            <i class="fas fa-trash text-danger" />
          </b-button>
        </div>
        <div class="col-4 form-group text-muted text-truncate">
          <span>{{ preview[index] }}</span>
          <div
            v-if="typeof column.error !== 'undefined'"
            class="text-danger"
          >
            {{ column.error }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
  .action-header {
      line-height: 1.5;
      vertical-align: middle;
  }
  .column-assoc select#subject {

    // The select element is set to required
    // as long as the selected options value
    // is empty the element is not valid.
    &:invalid, [disabled] {
      color: #999;
      background-color: #EEE;
    }

    option {
      color: black;
      background-color: transparent;
    }
  }
</style>
<script>
export const dataMembers = [{
  name: undefined,
  label: 'Nincs hozzárendelve'
}, {
  name: 'subject',
  label: 'Tárgy',
}, {
  name: 'esp_id',
  label: 'Azonosító',
}, {
  name: 'recipients',
  label: 'Címzettek',
}, {
  name: 'opens',
  label: 'Megnyitások',
}, {
  name: 'opens_unique',
  label: 'Egyedi megnyitás',
}, {
  name: 'clicks',
  label: 'Kattintások',
}, {
  name: 'clicks_unique',
  label: 'Egyedi kattintás',
}, {
  name: 'bounces',
  label: 'Bounce',
}, {
  name: 'unsubscribes',
  label: 'Leiratkozók',
}, {
  name: 'dispatched_at',
  label: 'Kiküldés időpontja',
}]

export default {
  props: {
    rows: {
      type: Array,
      default: () => [[]]
    },
    hasHeader: {
      type: Boolean,
      default: false
    },
    dateFormat: {
      type: String,
      default: 'auto'
    },
    value: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      dataMembers,
      columns: [],
      error: '',
    }
  },
  computed: {
    header() {
      if (this.rows.length < 1) {
        return []
      }

      if (this.hasHeader) {
        return this.rows[0]
      } else {
        return _.times(this.rows[0].length)
      }
    },
    preview() {
      return this.rows.length < 2 ? [] : this.rows[1]
    },
    members() {
      return _.map(this.dataMembers, dataMember => ({
        ...dataMember,
        selected: typeof dataMember.name !== 'undefined' && typeof this.value[dataMember.name] !== 'undefined',
      }))
    }
  },
  watch: {
    header: {
      deep: true,
      immediate: true,
      handler(header) {
        this.columns = []

        _.forEach(header, column => {
          const value = _.findKey(this.value, value => value === column)
          const error = typeof this.errors[value] !== 'undefined' ? this.errors[value].join(' ') : undefined

          this.columns.push({
            name: column,
            value: value,
            error: error
          })
        })

        this.error = typeof this.value.subject !== 'undefined' ? '' : 'A tárgy hozzárendelése kötelező!'
      }
    },
    columns: {
      deep: true,
      handler(columns) {
        var assoc = {}
        _.forEach(columns, column => {
          if(typeof column.value !== 'undefined') {
            assoc[column.value] = column.name
          }
        })

        if(_.isEqual(assoc, this.value)) {
          return
        }

        this.$emit('input', assoc)
      }
    }
  },
  mounted() {
  },
  methods: {
    clearAll() {
      this.columns = _.map(this.header, column =>({
        name: column
      }))
    },
    clear(name) {
      this.columns = _.map(this.columns, column => {
        return {
          name: column.name,
          value: column.name === name ? undefined : column.value
        }
      })
    }
  }
}
</script>